import clsx from 'clsx';
import type { FC, PropsWithChildren } from 'react';

import styles from './Foldable.module.scss';

type FoldableProps = {
  show?: boolean;
  className?: string;
};
const Foldable: FC<PropsWithChildren<FoldableProps>> = ({ show, className, children }) => (
  <div
    className={clsx(className, styles['foldable'], show && styles['unfolded'])}
    aria-hidden={!show}
  >
    <div className={clsx(!show && styles['inner'])}>{children}</div>
  </div>
);

export default Foldable;
